<template>
  <!-- 会员卡管理-会员卡配置 -->
  <div class="vip_card-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog(1)"
            >添加会员卡</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="amount" label="面值" align="center" sortable>
        </el-table-column>
        <el-table-column prop="frequency" label="发币频率" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.frequency }}</span>
            <span v-if="row.frequency_unit === 1">小时</span>
            <span v-if="row.frequency_unit === 2">日</span>
          </template>
        </el-table-column>
        <el-table-column prop="time1" label="失效时间" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.overdue }}</span>
            <span v-if="row.overdue_unit === 1">小时</span>
            <span v-if="row.overdue_unit === 2">日</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status === 1">生效中</el-tag>
            <el-tag type="info" v-if="row.status === 2">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              size="small"
              @click="openDialog(2, row)"
              style="margin-right: 10px"
              >编辑</el-button
            >
            <el-upload
              accept=".xls,.xlsx"
              :show-file-list="false"
              :on-success="onSuccess"
              :on-error="onError"
              style="display: inline-flex; margin-right: 10px"
              :action="action + '/' + row.id"
              :headers="headers"
            >
              <el-button type="primary" size="small" icon="el-icon-upload2">
                上传用户表
              </el-button>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        class="underBar"
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page || 1"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <VipCradDialog
      v-model="dialogInfos"
      :visible="dialogVisible"
      :type="dialogType"
      @close="dialogVisible = false"
      @refresh="getData()"
    ></VipCradDialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { getCookie } from '@/utils/cookie'
import VipCradDialog from '../../components/vip/VipCradDialog.vue'

export default {
  name: 'vip_card',
  components: {
    VipCradDialog
  },
  data() {
    return {
      dialogVisible: false,//用户详情信息显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}member_card_user`
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData('member_card', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.dialogVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.vip_card-box {
  header {
  }

  .body-box {
  }
}
</style>